import { useState, useEffect } from 'react';
import { fetchAppliedJobs } from '../../../services/api';

const useAppliedJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAppliedJobs = async () => {
      try {
        setLoading(true);
        const data = await fetchAppliedJobs();
        const normalized = Array.isArray(data)
          ? data
              .map((item) => {
                if (!item) return null;
                if (item.job) {
                  return {
                    ...item.job,
                    hasApplied: true,
                    applicationId: item.id,
                    applicationStatus: item.status,
                    applicationCreatedAt: item.createdAt,
                    applicationUpdatedAt: item.updatedAt,
                    applicationMessage: item.message,
                    applicationProposedBudget: item.proposedBudget,
                  };
                }
                return { ...item, hasApplied: true };
              })
              .filter(Boolean)
          : [];
        setJobs(normalized);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadAppliedJobs();
  }, []);

  return { jobs, loading, error, setJobs };
};

export default useAppliedJobs;
